function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63,19H18.9V10H63ZM20.9,17H61V12H20.9Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.52 73.06 66.09 73.06 66.09 71.06 73.52 71.06 73.52 15.53 62.64 15.53 62.64 13.53 75.52 13.53 75.52 73.06",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.53 58.28 6.53 58.28 6.53 13.53 15.57 13.53 15.57 15.53 8.53 15.53 8.53 58.28",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,65.69l-49.33,0v-2l49.33,0c1.09,0,1.93-1.44,1.93-2.67,0-.28-.06-2.74-1.93-2.74h-52v-2h52c2.7,0,3.93,2.45,3.93,4.74S62.06,65.69,59.71,65.69Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.38,73.08c-2.34,0-3.92-2.41-3.92-4.67s1.23-4.74,3.92-4.74v2c-1.87,0-1.92,2.46-1.92,2.74,0,1.24.84,2.67,1.92,2.67l52.51,0v2Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.74,41.05c-.08-.09-1.83-2.49-1.39-6.91S26,27.88,26.1,27.81l1.25,1.55c-.06.06-1.65,1.43-2,5s1,5.5,1,5.51Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,53.1l-1.26-1.56c.07,0,1.66-1.42,2-5s-.94-5.45-1-5.52l1.61-1.2c.07.1,1.82,2.49,1.38,6.92S25.07,53,25,53.1Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.41,41.05c-.07-.09-1.83-2.49-1.38-6.91s2.65-6.26,2.74-6.33L55,29.37l-.62-.78.63.77c-.07.06-1.66,1.43-2,5s.94,5.44,1,5.52Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65,53.1l-1.26-1.56c.07,0,1.66-1.42,2-5s-.94-5.45-1-5.52l1.6-1.2c.07.1,1.83,2.49,1.38,6.92S52.74,53,52.65,53.1Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.57,41.05c-.07-.09-1.82-2.49-1.38-6.91s2.65-6.26,2.75-6.33l1.25,1.55c-.07.06-1.65,1.43-2,5a8.49,8.49,0,0,0,1,5.51Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.81,53.1l-1.25-1.56c.06,0,1.65-1.42,2-5s-.94-5.45-1-5.52l1.6-1.2c.08.1,1.83,2.49,1.39,6.92S38.91,53,38.81,53.1Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.58 19.78 10.34 18.21 15.03 14.53 10.34 10.84 11.58 9.27 18.27 14.53 11.58 19.78",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.39 77.33 63.46 72.08 70.17 66.81 71.41 68.38 66.73 72.05 71.6 75.73 70.39 77.33",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.88 31.98 26.73 26.44 21.78 30.02 20.61 28.4 27.66 23.3 30.74 31.26 28.88 31.98",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.55 31.98 54.4 26.44 49.46 30.02 48.28 28.4 55.33 23.3 58.41 31.26 56.55 31.98",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.71 31.98 40.56 26.44 35.62 30.02 34.45 28.4 41.49 23.3 44.58 31.26 42.71 31.98",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaq);
export default __webpack_public_path__ + "static/media/iaq.f3a442bb496d0a5da20c05b66ef7469b.svg";
export { ForwardRef as ReactComponent };